import React, { useState, useEffect } from "react";
import { useNavigate,useParams } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../../AuthContext";
import { API_BASE_URL } from "../../config";
import DatePicker from "react-datepicker";
import dayjs from "dayjs";
import "react-datepicker/dist/react-datepicker.css";
import { type } from "@testing-library/user-event/dist/type";
import Header from "../Header";

const Managerreadingedit = () => {
  const { id } = useParams();
  const navigate = useNavigate(); // Call useNavigate to get navigate function
  const { logout } = useAuth();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isAmountEdit, setIsAmountEdit] = useState(false);
  const [credentials] = useState({
    token: localStorage.getItem("authToken"),
    id: id,
  });
  const [credentialsfilter,credentialsfilternew] = useState({
    token: localStorage.getItem("authToken"),
    filterDateG: '',
    filterDateM: '',
    filterTimeG: null,
    filterTimeM: null,
  });
  const [savedData, setSavedData] = useState([]);
  const [banksavedData, setbankSavedData] = useState([]);
  const [bankStatement, setbankStatement] = useState([]);
  const [expineseData, setExpinesedData] = useState([]);
  const [product, setProduct] = useState([]);
  const [productdata, setProductdata] = useState([]);
  const [gtime, setGTime] = useState([]);
  const [mtime, setMTime] = useState([]);
  const [filterUpdated, setFilterUpdated] = useState(false);
  const [previous_day_total, setPrevious_day_total] = useState(0);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const [fields, setFields] = useState(() => {
    const savedFields = localStorage.getItem("edit_fields");
    return savedFields ? JSON.parse(savedFields) : [];
  });
  const [mineshFields, setMineshFields] = useState(() => {
    const savedMineshFields = localStorage.getItem("edit_mineshFields");
    return savedMineshFields ? JSON.parse(savedMineshFields) : [];
  });
  const [extraFields, setExtraFields] = useState(() => {
    const savedExtraFields = localStorage.getItem("edit_extraFields");
    return savedExtraFields ? JSON.parse(savedExtraFields) : [];
  });
  const [anotherCustomFields, setAnotherCustomFields] = useState(() => {
    const savedAnotherCustomFields = localStorage.getItem("edit_anotherCustomFields");
    return savedAnotherCustomFields ? JSON.parse(savedAnotherCustomFields) : [];
  });
  const [customTrFields, setCustomTrFields] = useState(() => {
    const savedCustomTrFields = localStorage.getItem("edit_customTrFields");
    return savedCustomTrFields ? JSON.parse(savedCustomTrFields) : [];
  });
  const [cardFields, setCardFields] = useState(() => {
    const savedCardFields = localStorage.getItem("edit_cardFields");
    return savedCardFields ? JSON.parse(savedCardFields) : [];
  });
  const [BankDepositfields, setBankDepositfields] = useState(() => {
    const savedBankDepositfields = localStorage.getItem("edit_BankDepositfields");
    return savedBankDepositfields ? JSON.parse(savedBankDepositfields) : [];
  });
  const [BankChargesfields, setBankChargesfields] = useState(() => {
    const savedBankChargesfields = localStorage.getItem("edit_BankChargesfields");
    return savedBankChargesfields ? JSON.parse(savedBankChargesfields) : [];
  });
  const [BankDepositChargefields, setBankDepositChargefields] = useState(() => {
    const savedBankDepositChargefields = localStorage.getItem("edit_BankDepositChargefields");
    return savedBankDepositChargefields ? JSON.parse(savedBankDepositChargefields) : [];
  });
  const handleFilterChangeDate = (date, fieldName) => {
    const formattedDate = dayjs(date).format("YYYY-MM-DD");
    credentialsfilternew((prev) => ({
      ...prev,
      [fieldName]: formattedDate, // Dynamically updates the correct field
    }));
    if (fieldName == "filterDateG") {
      credentialsfilternew((prev) => ({
        ...prev,
        filterTimeG: null, // Dynamically updates the correct field
      }));
    }
    if (fieldName == "filterDateM") {
      credentialsfilternew((prev) => ({
        ...prev,
        filterTimeM: null, // Dynamically updates the correct field
      }));
    }
    setFilterUpdated(true);
  };
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    credentialsfilternew((prev) => ({
      ...prev,
      [name]: value, // Dynamically updates the correct field
    }));
    setFilterUpdated(true);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess("");

    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/managerreadingsave`,
        {
          id,
          credentialsfilter,
          product,
          fields,
          mineshFields,
          extraFields,
          anotherCustomFields,
          customTrFields,
          cardFields,
          BankDepositfields,
          BankChargesfields,
          total_credit: getInputTotal(),
          total_deposit: getMineshTotal(),
          total_expinese: getExtraTotal(),
          total_card: getCardTotal(),
          total_outside: getCustomTotal(),
          total_inside: getAnotherCustomTotal(),
          total_bank_deposit: getBankDepositfields(),
          previous_day_total: previous_day_total,
          current_day_total: Current_day_total(),
          net_total: Net_total(),
          final_total: Final_total(),
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setSuccess("Item update successfully!");
      localStorage.removeItem('edit_fields');
      localStorage.removeItem('edit_mineshFields');
      localStorage.removeItem('edit_extraFields');
      localStorage.removeItem('edit_anotherCustomFields');
      localStorage.removeItem('edit_customTrFields');
      localStorage.removeItem('edit_cardFields');
      localStorage.removeItem('edit_BankDepositfields');
      localStorage.removeItem('edit_BankChargesfields');
      localStorage.removeItem('edit_BankDepositChargefields');

      //window.location.reload();
      navigate("/dashboard"); // Use navigate to redirect
      // Clear form after successful submission
    } catch (error) {
      //setError('Failed to add product: ' + (error.response?.data?.message || error.message));
      //setLoading(false);
      logout();
      navigate("/"); // Use navigate to redirect
    }
  };

  const fetchdetaildata = async () => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/managerreadingdetail`,
        credentials,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.status) {
        setProductdata(response.data.data);

        setIsAmountEdit(response.data.data.isAmountEdit);
        setFields(response.data.data.Credits);
        setMineshFields(response.data.data.Deposit);
        setExtraFields(response.data.data.Expinese);
        setAnotherCustomFields(response.data.data.Inside);
        setCustomTrFields(response.data.data.Outside);
        setCardFields(response.data.data.Card);
        setBankDepositfields(response.data.data.Bankdeposit);
        setBankChargesfields(response.data.data.Bankcharges);
        setBankDepositChargefields(response.data.data.bankStatement);

        credentialsfilternew((prev) => ({
          ...prev,
          'filterTimeG': response.data.data.id_G,
          'filterTimeM': response.data.data.id_M,
          'filterDateG': response.data.data.DateG,
          'filterDateM': response.data.data.DateM,
        }));
        setFilterUpdated(true);
      }
    } catch (err) {
      logout();
      //setError(response.data.message);
      navigate("/"); // Use navigate to redirect
    }
  };

  // Load saved data from local storage on component mount
  useEffect(() => {
    const authState = localStorage.getItem("authToken");
    if (authState) {
      fetchdetaildata();
    }
    const role = localStorage.getItem("role");
    if (role) {
      if (role=='ADMIN') {
        
      }else{
        navigate('/dashboard');
      }
    }else{
      navigate('/dashboard');
    }
  }, []); // Empty dependency array means this effect runs once on mount

  const fetchfirstdata = async () => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/mainreading`,
        credentialsfilter,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.status) {
        //setProducts(response.data.data);
        setProduct(response.data.data);
        setGTime(response.data.g_times);
        setMTime(response.data.m_times);
        setSavedData(response.data.namesuggestions);
        setbankSavedData(response.data.banksuggestions);
        setbankStatement(response.data.bankStatement);
        setExpinesedData(response.data.expinesesuggestions);
        setPrevious_day_total(response.data.previous_day_total);
        credentialsfilternew((prev) => ({
          ...prev,
          'filterDateG': response.data.g_date,
          'filterDateM': response.data.m_date,
          'filterTimeG': response.data.g_time,
          'filterTimeM': response.data.m_time,
        }));
      }
    } catch (err) {
      logout();
      //setError(response.data.message);
      navigate("/"); // Use navigate to redirect
    }
  };

  useEffect(() => {
    if (filterUpdated) {
      const authState = localStorage.getItem("authToken");
      if (authState) {
        fetchfirstdata();
        setIsLoggedIn(true);
        setFilterUpdated(false);
      }
    }
  }, [filterUpdated]); // Empty dependency array means this effect runs once on mount

  useEffect(() => {
    const savedFields = localStorage.getItem("edit_fields");
    if (savedFields) {
      setFields(JSON.parse(savedFields));
    }
    const savedMineshFields = localStorage.getItem("edit_mineshFields");
    if (savedMineshFields) {
      setMineshFields(JSON.parse(savedMineshFields));
    }
    const savedExtraFields = localStorage.getItem("edit_extraFields");
    if (savedExtraFields) {
      setExtraFields(JSON.parse(savedExtraFields));
    }
    const savedAnotherCustomFields = localStorage.getItem("edit_anotherCustomFields");
    if (savedAnotherCustomFields) {
      setAnotherCustomFields(JSON.parse(savedAnotherCustomFields));
    }
    const savedCustomTrFields = localStorage.getItem("edit_customTrFields");
    if (savedCustomTrFields) {
      setCustomTrFields(JSON.parse(savedCustomTrFields));
    }
    const savedCardFields = localStorage.getItem("edit_cardFields");
    if (savedCardFields) {
      setCardFields(JSON.parse(savedCardFields));
    }
    const savedBankDepositfields = localStorage.getItem("edit_BankDepositfields");
    if (savedBankDepositfields) {
      setBankDepositfields(JSON.parse(savedBankDepositfields));
    }
    const savedBankChargesfields = localStorage.getItem("edit_BankChargesfields");
    if (savedBankChargesfields) {
      setBankChargesfields(JSON.parse(savedBankChargesfields));
    }
    const savedBankDepositChargefields = localStorage.getItem("edit_BankDepositChargefields");
    if (savedBankDepositChargefields) {
      setBankDepositChargefields(JSON.parse(savedBankDepositChargefields));
    }
  }, []); 
  useEffect(() => {
    localStorage.setItem("edit_fields", JSON.stringify(fields));
  }, [fields]);
  useEffect(() => {
    localStorage.setItem("edit_extraFields", JSON.stringify(extraFields));
  }, [extraFields]);
  useEffect(() => {
    localStorage.setItem("edit_anotherCustomFields", JSON.stringify(anotherCustomFields));
  }, [anotherCustomFields]);
  useEffect(() => {
    localStorage.setItem("edit_customTrFields", JSON.stringify(customTrFields));
  }, [customTrFields]);
  const calculateBankDepositCharges = (bankStatement,cards, mineshs, deposits, charges) => {
    
    let bankStatementMap = {};
    // Process bankStatement safely
    if (bankStatement?.data?.length > 0) {
      bankStatementMap = bankStatement.data.reduce((acc, item) => {
        if (item.bank_name && item.total) {
          acc[item.bank_name] = (acc[item.bank_name] || 0) + Number(item.total);
        }
        return acc;
      }, {});
    }
    
    
    const cardMap = cards.reduce((acc, item) => {
      if (item.bank_name && item.amount) {
        acc[item.bank_name] = (acc[item.bank_name] || 0) + Number(item.amount);
      }
      return acc;
    }, {});
  
    const mineshdMap = mineshs.reduce((acc, item) => {
      if (item.bank_show && item.bank_name && item.amount) {
        acc[item.bank_name] = (acc[item.bank_name] || 0) + Number(item.amount);
      }
      return acc;
    }, {});
  
    const depositMap = deposits.reduce((acc, item) => {
      if (item.name && item.amount) {
        acc[item.name] = (acc[item.name] || 0) + Number(item.amount);
      }
      return acc;
    }, {});
  
    const chargesMap = charges.reduce((acc, item) => {
      if (item.bank_name && item.amount) {
        acc[item.bank_name] = (acc[item.bank_name] || 0) + Number(item.amount);
      }
      return acc;
    }, {});
  
    const allBanks = new Set([
      ...Object.keys(bankStatementMap),
      ...Object.keys(cardMap),
      ...Object.keys(mineshdMap),
      ...Object.keys(depositMap),
      ...Object.keys(chargesMap),
    ]);
  
    let all_bank_total_deposite = 0;
    let all_bank_total_charges = 0;
  
    const combined = Array.from(allBanks).map((bank) => {
      const deposite =
        //(bankStatementMap[bank] || 0) + 
        (cardMap[bank] || 0) +
        (mineshdMap[bank] || 0) +
        (depositMap[bank] || 0);
      
        const total =
        (bankStatementMap[bank] || 0);

      const charges = chargesMap[bank] || 0;
  
      all_bank_total_deposite += deposite;
      all_bank_total_charges += charges;
  
      return {
        bank_name: bank,
        deposite,
        charges,
        total,
        bank_total: deposite - charges,
      };
    });
  
    const all_bank_bank_total = all_bank_total_deposite - all_bank_total_charges;
  
    return {
      data: combined,
      all_bank_total_deposite,
      all_bank_total_charges,
      all_bank_bank_total,
    };
  };  
  useEffect(() => {
    // Save individual fields
    localStorage.setItem("edit_cardFields", JSON.stringify(cardFields));
    localStorage.setItem("edit_mineshFields", JSON.stringify(mineshFields));
    localStorage.setItem("edit_BankDepositfields", JSON.stringify(BankDepositfields));
    localStorage.setItem("edit_BankChargesfields", JSON.stringify(BankChargesfields));
  
    // Recalculate and store combined data
    const updated = calculateBankDepositCharges(bankStatement,cardFields,mineshFields,BankDepositfields, BankChargesfields);
    setBankDepositChargefields(updated);
    localStorage.setItem("edit_BankDepositChargefields", JSON.stringify(updated));
  }, [bankStatement,cardFields,mineshFields,BankDepositfields, BankChargesfields]);
  const getInputTotal = () => {
    return fields.reduce(
      (total, field) => total + (parseFloat(field.amount) || 0),
      0
    );
  };
  const getMineshTotal = () => {
    return mineshFields.reduce(
      (total, field) =>
        field.mode === 'Cash'
          ? total + (Math.abs(parseFloat(field.amount)) || 0)
          : total,
      0
    );
  };
  const getCardTotal = () => {
    return cardFields.reduce(
      (total, field) => total + (parseFloat(field.amount) || 0),
      0
    );
  };
  const getFinalTotal = () => {
    return (
      -getAnotherCustomTotal() +
      getExtraTotal() -
      getMineshTotal() +
      getInputTotal() +
      getCardTotal() +
      getCustomTotal()
    );
  };
  const Current_day_total = () => {
    if(productdata.grandTotal){
      return productdata.grandTotal - getFinalTotal();
    }else{
      return getFinalTotal();
    }
  };
  const Net_total = () => {
    if(BankDepositChargefields.all_bank_bank_total){
      return BankDepositChargefields.all_bank_bank_total + Current_day_total();
    }else{
      return Current_day_total();
    }
  };
  const Final_total = () => {
    return previous_day_total + Net_total();
  };
  const getExtraTotal = () => {
    return extraFields.reduce(
      (total, field) => total + (parseFloat(field.amount) || 0),
      0
    );
  };
  const getCustomTotal = () => {
    return customTrFields.reduce(
      (total, field) => total + (parseFloat(field.amount) || 0),
      0
    );
  };
  const getAnotherCustomTotal = () => {
    return anotherCustomFields.reduce(
      (total, field) => total + (parseFloat(field.amount) || 0),
      0
    );
  };
  const getBankDepositfields = () => {
    return BankDepositfields.reduce(
      (total, field) => total + (parseFloat(field.amount) || 0),
      0
    );
  };
  const getBankChargesfields = () => {
    return BankChargesfields.reduce(
      (total, field) => total + (parseFloat(field.amount) || 0),
      0
    );
  };
  // Add new input row for adding
  const addAnotherCustomField = () => {
    setAnotherCustomFields([...anotherCustomFields, { name: "", amount: "" }]);
  };
  // Add new input row for adding
  const addCustomTrField = () => {
    setCustomTrFields([...customTrFields, { name: "", amount: "" }]);
  };
  // Add new input row for adding
  const addField = () => {
    setFields([...fields, { amount: "", name: "" }]);
  };
  // Add new input row for minesh (subtracting)
  const addMineshField = () => {
    setMineshFields([...mineshFields, { amount: "", name: "" ,mode: "Cash",bank_show:false,bank_name:'' }]);
  };
  const addExtraField = () => {
    setExtraFields([...extraFields, { amount: "", name: "" }]);
  };
  const addCardField = () => {
    setCardFields([...cardFields, { amount: "", name: "", time: "",mode:'Scan',bank_name:"" }]);
  };
  const addBankDepositfields = () => {
    setBankDepositfields([...BankDepositfields, { name: "", amount: "" }]);
  };
  const addBankChargesfields = () => {
    setBankChargesfields([...BankChargesfields, { bank_name:"" , amount: "", name: "" }]);
  };
  // Function to remove a field from a given list by index
  const removeField = (index, list, setList) => {
    setList(list.filter((_, i) => i !== index));
  };
  return (
    <>
      <Header />
      <div className="du-detils">
        <div className="container">
          <form
            onSubmit={isLoggedIn ? handleSubmit : undefined}
            action="javascript:void(0);"
          >
            {" "}
            <div className="top-bar-heading">
              <div className="row">
                <div className="col-md-1">
                  <p>Gilbarco</p>
                </div>
                <div className="col-md-3">
                  <div className="row">
                    <div className="col-md-5 col-4">
                      <DatePicker
                        selected={credentialsfilter.filterDateG}
                        onChange={isAmountEdit ? (date) => handleFilterChangeDate(date, "filterDateG") : undefined}
                        disabled={!isAmountEdit}
                        name="filterDateG"
                        dateFormat="yyyy-MM-dd"
                        placeholderText="Date"
                        className="form-control"
                      />

                    </div>
                    <div className="col-md-6 col-6">
                      <select
                        onChange={isAmountEdit ? handleFilterChange : undefined}
                        disabled={!isAmountEdit}
                        name="filterTimeG"
                        className="form-control"
                        value={credentialsfilter.filterTimeG}
                      >
                        {gtime && typeof gtime === "object"
                          ? Object.entries(gtime).map(([key, value]) => (
                              <option key={key} value={key}>
                                {value}
                              </option>
                            ))
                          : ""}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="product-form ms">
              <div className="row">
                <div className="col-md-1">
                  <p>MS</p>
                </div>
                <div className="col-md-2 col-6">
                  <input
                    type="number"
                    name="g_MS_opening"
                    className="form-control"
                    placeholder="Opening"
                    value={product.g_MS_opening}
                    disabled
                  />
                </div>
                <div className="col-md-2 col-6">
                  <input
                    type="number"
                    name="g_MS_closing"
                    className="form-control"
                    placeholder="Closing"
                    value={product.g_MS_closing}
                    disabled
                  />
                </div>
                <div className="col-md-1 col-6">
                  <input
                    type="number"
                    name="g_MS_testing"
                    className="form-control"
                    placeholder="Testing"
                    value={product.g_MS_testing}
                    disabled
                  />
                </div>
                <div className="col-md-2 col-6">
                  <input
                    type="number"
                    name="g_MS_subtotal"
                    className="form-control"
                    placeholder="Subtotal"
                    value={product.g_MS_subtotal}
                    disabled
                  />
                </div>
                <div className="col-md-2 col-6">
                  <input
                    type="number"
                    name="g_MS_price"
                    className="form-control"
                    placeholder="Price"
                    value={product.g_MS_price}
                    disabled
                  />
                </div>
                <div className="col-md-2 col-6">
                  <input
                    type="number"
                    name="g_MS_total"
                    className="form-control"
                    placeholder="Total"
                    value={product.g_MS_total}
                    disabled
                  />
                </div>
              </div>
            </div>
            <div className="product-form hsd">
              <div className="row">
                <div className="col-md-1">
                  <p>HSD</p>
                </div>
                <div className="col-md-2 col-6">
                  <input
                    type="number"
                    name="g_HSD_opening"
                    className="form-control"
                    placeholder="Opening"
                    value={product.g_HSD_opening}
                    disabled
                  />
                </div>
                <div className="col-md-2 col-6">
                  <input
                    type="number"
                    name="g_HSD_closing"
                    className="form-control"
                    placeholder="Closing"
                    value={product.g_HSD_closing}
                    disabled
                  />
                </div>
                <div className="col-md-1 col-6">
                  <input
                    type="number"
                    name="g_HSD_testing"
                    className="form-control"
                    placeholder="Testing"
                    value={product.g_HSD_testing}
                    disabled
                  />
                </div>
                <div className="col-md-2 col-6">
                  <input
                    type="number"
                    name="g_HSD_subtotal"
                    className="form-control"
                    placeholder="Subtotal"
                    value={product.g_HSD_subtotal}
                    disabled
                  />
                </div>
                <div className="col-md-2 col-6">
                  <input
                    type="number"
                    name="g_HSD_price"
                    className="form-control"
                    placeholder="Price"
                    value={product.g_HSD_price}
                    disabled
                  />
                </div>
                <div className="col-md-2 col-6">
                  <input
                    type="number"
                    name="g_HSD_total"
                    className="form-control"
                    placeholder="Total"
                    value={product.g_HSD_total}
                    disabled
                  />
                </div>
              </div>
            </div>
            <div className="top-bar-heading ">
              <div className="row">
                <div className="col-md-1">
                  <p>Midco</p>
                </div>
                <div className="col-md-3">
                  <div className="row">
                    <div className="col-md-5 col-5">
                      <DatePicker
                        selected={credentialsfilter.filterDateM}
                        onChange={isAmountEdit ? (date) => handleFilterChangeDate(date, "filterDateM") : undefined}
                        disabled={!isAmountEdit}
                        name="filterDateM"
                        dateFormat="yyyy-MM-dd"
                        placeholderText="Date"
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-5 col-6">
                      <select
                        onChange={isAmountEdit ? handleFilterChange : undefined}
                        disabled={!isAmountEdit}
                        name="filterTimeM"
                        className="form-control"
                        value={credentialsfilter.filterTimeM}
                      >
                        {mtime && typeof mtime === "object"
                          ? Object.entries(mtime).map(([key, value]) => (
                              <option key={key} value={key}>
                                {value}
                              </option>
                            ))
                          : ""}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="product-form ms">
              <div className="row">
                <div className="col-md-1">
                  <p>MS</p>
                </div>
                <div className="col-md-2 col-6">
                  <input
                    type="number"
                    name="m_MS_opening"
                    className="form-control"
                    placeholder="Opening"
                    value={product.m_MS_opening}
                    disabled
                  />
                </div>
                <div className="col-md-2 col-6">
                  <input
                    type="number"
                    name="m_MS_closing"
                    className="form-control"
                    placeholder="Closing"
                    value={product.m_MS_closing}
                    disabled
                  />
                </div>
                <div className="col-md-1 col-6">
                  <input
                    type="number"
                    name="m_MS_testing"
                    className="form-control"
                    placeholder="Testing"
                    value={product.m_MS_testing}
                    disabled
                  />
                </div>
                <div className="col-md-2 col-6">
                  <input
                    type="number"
                    name="m_MS_subtotal"
                    className="form-control"
                    placeholder="Subtotal"
                    value={product.m_MS_subtotal}
                    disabled
                  />
                </div>
                <div className="col-md-2 col-6">
                  <input
                    type="number"
                    name="m_MS_price"
                    className="form-control"
                    placeholder="Price"
                    value={product.m_MS_price}
                    disabled
                  />
                </div>
                <div className="col-md-2 col-6">
                  <input
                    type="number"
                    name="m_MS_total"
                    className="form-control"
                    placeholder="Total"
                    value={product.m_MS_total}
                    disabled
                  />
                </div>
              </div>
            </div>
            <div className="product-form hsd">
              <div className="row">
                <div className="col-md-1">
                  <p>HSD</p>
                </div>
                <div className="col-md-2 col-6">
                  <input
                    type="number"
                    name="m_HSD_opening"
                    className="form-control"
                    placeholder="Opening"
                    value={product.m_HSD_opening}
                    disabled
                  />
                </div>
                <div className="col-md-2 col-6">
                  <input
                    type="number"
                    name="m_HSD_closing"
                    className="form-control"
                    placeholder="Closing"
                    value={product.m_HSD_closing}
                    disabled
                  />
                </div>
                <div className="col-md-1 col-6">
                  <input
                    type="number"
                    name="m_HSD_testing"
                    className="form-control"
                    placeholder="Testing"
                    value={product.m_HSD_testing}
                    disabled
                  />
                </div>
                <div className="col-md-2 col-6">
                  <input
                    type="number"
                    name="m_HSD_subtotal"
                    className="form-control"
                    placeholder="Subtotal"
                    value={product.m_HSD_subtotal}
                    disabled
                  />
                </div>
                <div className="col-md-2 col-6">
                  <input
                    type="number"
                    name="m_HSD_price"
                    className="form-control"
                    placeholder="Price"
                    value={product.m_HSD_price}
                    disabled
                  />
                </div>
                <div className="col-md-2 col-6">
                  <input
                    type="number"
                    name="m_HSD_total"
                    className="form-control"
                    placeholder="Total"
                    value={product.m_HSD_total}
                    disabled
                  />
                </div>
              </div>
            </div>
            <div className="product-form total-data">
              <div className="row">
                <div className="col-md-4 col-6">
                  <label>MS Total Amount</label>
                  <input
                    type="number"
                    name="ms_grandTotal"
                    className="form-control"
                    placeholder="Grand Total"
                    value={product.ms_grandTotal}
                    disabled
                  />
                </div>
                <div className="col-md-4 col-6">
                  <label>HSD Total Amount</label>
                  <input
                    type="number"
                    name="hsd_grandTotal"
                    className="form-control"
                    placeholder="Grand Total"
                    value={product.hsd_grandTotal}
                    disabled
                  />
                </div>
                <div className="col-md-4 col-12">
                  <label>Total Amount</label>
                  <input
                    type="number"
                    name="grandTotal"
                    className="form-control"
                    placeholder="Grand Total"
                    value={product.grandTotal}
                    disabled
                  />
                </div>
              </div>
            </div>
            <div className="product-form all-bottom-fild">
              <div className="row">
                <div className="col-12 col-md-4 bg-green-100 rounded">
                  <h5 className="font-bold">Credit</h5>

                  {fields.map((field, index) => (
                    <div key={index}>
                      <input
                        type="number"
                        placeholder="Amount"
                        value={field.amount}
                        onChange={
                          isAmountEdit
                            ? (e) => {
                                const newFields = [...fields];
                                newFields[index].amount = e.target.value;
                                setFields(newFields);
                              }
                            : undefined
                        }
                        disabled={!isAmountEdit}
                        className="border p-2 rounded col-3"
                        required
                      />

                      <input
                        type="text"
                        placeholder="Name"
                        value={field.name}
                        onChange={(e) => {
                          const newFields = [...fields];
                          newFields[index].name = e.target.value;
                          setFields(newFields);
                        }}
                        className="border p-2 rounded col-8"
                        list="name-suggestions"
                        required="required"
                      />
                      {isAmountEdit && fields.length > 0 && (
                        <button
                          type="button"
                          onClick={() => removeField(index, fields, setFields)}
                          className="p-2 bg-red-500 text-white rounded col-1"
                        >
                          -
                        </button>
                      )}
                    </div>
                  ))}
                  <datalist id="name-suggestions">
                    {savedData.map((item, index) => (
                      <option key={index} value={item.name} />
                    ))}
                  </datalist>

                  {isAmountEdit && (
                    <button
                      type="button"
                      onClick={addField}
                      className="mt-2 p-2 bg-green-500 text-white rounded"
                    >
                      Add More
                    </button>
                  )}
                    <div className="mt-4 p-2 bg-yellow-200 text-black font-bold rounded">
                      Total Credit Amount: {getInputTotal()}
                    </div>
                </div>

                {/* Dynamic Input Fields for Minesh (Subtracting) */}
                <div className="col-12 col-md-4 bg-red-100 rounded">
                  <h5 className="font-bold">Deposit Amount</h5>
                  {mineshFields.map((field, index) => (
                    <div key={index}>
                      <input
                        type="number"
                        placeholder="Amount to Subtract"
                        value={field.amount}
                        onChange={
                          isAmountEdit
                            ? (e) => {
                                const newFields = [...mineshFields];
                                newFields[index].amount = e.target.value;
                                setMineshFields(newFields);
                              }
                            : undefined
                        }
                        disabled={!isAmountEdit}
                        className="border p-2 rounded col-3"
                        required="required"
                      />
                      <input
                        type="text"
                        placeholder="Name"
                        value={field.name}
                        onChange={(e) => {
                          const newFields = [...mineshFields];
                          newFields[index].name = e.target.value;
                          setMineshFields(newFields);
                        }}
                        className="border p-2 rounded col-8"
                        list="name-suggestions"
                        required="required"
                      />
                      <select 
                        value={field.mode}
                        onChange={(e) => {
                          const newFields = [...mineshFields];
                          newFields[index].mode = e.target.value;
                          setMineshFields(newFields);
                          if(e.target.value=='Cash'){
                            newFields[index].bank_show = false;
                            newFields[index].bank_name = '';
                          }else{
                            newFields[index].bank_show = true;
                          }
                          setMineshFields(newFields);
                        }}
                        className="border p-2 rounded col-8"
                        required="required"
                      >
                        <option value='Cash'>Cash</option>
                        <option value='Scan'>Scan</option>
                        <option value='Swipe'>Swipe</option>
                        <option value='Bank'>Bank</option>
                      </select>
                      <input
                        type="text"
                        placeholder="Bank Name"
                        value={field.bank_name}
                        onChange={(e) => {
                          const newFields = [...mineshFields];
                          newFields[index].bank_name = e.target.value;
                          setMineshFields(newFields);
                        }}
                        className="border p-2 rounded w-1/2 col-8"
                        required={field.bank_show}
                        list="bank_name-suggestions"
                        style={{ display: field.bank_show ? 'block' : 'none' }}
                      />
                      {isAmountEdit && mineshFields.length > 0 && (
                        <button
                          type="button"
                          onClick={() =>
                            removeField(index, mineshFields, setMineshFields)
                          }
                          className="p-2 bg-red-500 text-white rounded col-1"
                        >
                          -
                        </button>
                      )}
                    </div>
                  ))}
                  {isAmountEdit && (
                    <button
                      type="button"
                      onClick={addMineshField}
                      className="mt-2 p-2 bg-red-500 text-white rounded"
                    >
                      Add More
                    </button>
                  )}
                  <datalist id="bank_name-suggestions">
                    {banksavedData.map((item, index) => (
                      <option key={index} value={item.name} />
                    ))}
                  </datalist>
                  <div className="mt-4 p-2 bg-red-200 text-black font-bold rounded">
                    Total Deposit Amount : {getMineshTotal()}
                  </div>
                </div>
                {/* Dynamic Extra (Subtracting) */}
                <div className="col-12 col-md-4 bg-blue-100 rounded">
                  <h5 className="font-bold">Expinese</h5>
                  {extraFields.map((field, index) => (
                    <div key={index}>
                      <input
                        type="number"
                        placeholder="Amount"
                        value={field.amount}
                        onChange={
                          isAmountEdit
                            ? (e) => {
                                const newFields = [...extraFields];
                                newFields[index].amount = e.target.value;
                                setExtraFields(newFields);
                              }
                            : undefined
                        }
                        disabled={!isAmountEdit}
                        className="border p-2 rounded col-3"
                        required="required"
                      />
                      <input
                        type="text"
                        placeholder="Name"
                        value={field.name}
                        onChange={(e) => {
                          const newFields = [...extraFields];
                          newFields[index].name = e.target.value;
                          setExtraFields(newFields);
                        }}
                        className="border p-2 rounded col-8"
                        required="required"
                        list="Expinese-suggestions"
                      />
                      {isAmountEdit && extraFields.length > 0 && (
                        <button
                          type="button"
                          onClick={() =>
                            removeField(index, extraFields, setExtraFields)
                          }
                          className="p-2 bg-red-500 text-white rounded col-1"
                        >
                          -
                        </button>
                      )}
                    </div>
                  ))}
                  <datalist id="Expinese-suggestions">
                    {expineseData.map((item, index) => (
                      <option key={index} value={item.name} />
                    ))}
                  </datalist>
                  {isAmountEdit && (
                    <button
                      type="button"
                      onClick={addExtraField}
                      className="mt-2 p-2 bg-blue-500 text-white rounded"
                    >
                      Add More
                    </button>
                  )}
                  <div className="mt-4 p-2 bg-yellow-200 text-black font-bold rounded">
                    Total Extra Amount: {getExtraTotal()}
                  </div>
                </div>

                <div className="col-12 col-md-4 bg-blue-100 rounded">
                  <h5 className="font-bold">Card</h5>
                  {cardFields.map((field, index) => (
                    <div key={index}>
                      <input
                        type="number"
                        placeholder="Amount"
                        value={field.amount}
                        onChange={
                          isAmountEdit
                            ? (e) => {
                                const newFields = [...cardFields];
                                newFields[index].amount = e.target.value;
                                setCardFields(newFields);
                              }
                            : undefined
                        }
                        disabled={!isAmountEdit}
                        className="border p-2 rounded col-3"
                        required="required"
                      />
                      <input
                        type="text"
                        placeholder="Name"
                        value={field.name}
                        onChange={(e) => {
                          const newFields = [...cardFields];
                          newFields[index].name = e.target.value;
                          setCardFields(newFields);
                        }}
                        className="border p-2 rounded col-5"
                        required="required"
                      />
                      <input
                        type="text"
                        placeholder="Time"
                        value={field.time}
                        onChange={(e) => {
                          const newFields = [...cardFields];
                          newFields[index].time = e.target.value;
                          setCardFields(newFields);
                        }}
                        className="border p-2 rounded col-3"
                        required="required"
                      />
                      <select 
                        value={field.mode}
                        onChange={(e) => {
                          const newFields = [...cardFields];
                          newFields[index].mode = e.target.value;
                          setCardFields(newFields);
                        }}
                        className="border p-2 rounded col-8"
                        required="required"
                      >
                        <option value='Scan'>Scan</option>
                        <option value='Swipe'>Swipe</option>
                      </select>
                      <input
                        type="text"
                        placeholder="Bank Name"
                        value={field.bank_name}
                        onChange={(e) => {
                          const newFields = [...cardFields];
                          newFields[index].bank_name = e.target.value;
                          setCardFields(newFields);
                        }}
                        className="border p-2 rounded w-1/2 col-8"
                        required="required"
                        list="bank_name-suggestions"
                      />
                      {isAmountEdit && cardFields.length > 0 && (
                        <button
                          type="button"
                          onClick={() =>
                            removeField(index, cardFields, setCardFields)
                          }
                          className="p-2 bg-red-500 text-white rounded col-1"
                        >
                          -
                        </button>
                      )}
                    </div>
                  ))}
                  {isAmountEdit && (
                    <button
                      type="button"
                      onClick={addCardField}
                      className="mt-2 p-2 bg-blue-500 text-white rounded"
                    >
                      Add More
                    </button>
                  )}
                  <div className="mt-4 p-2 bg-yellow-200 text-black font-bold rounded">
                    Total Card Amount: {getCardTotal()}
                  </div>
                </div>

                <div className="col-12 col-md-4 bg-blue-100 rounded">
                  <h5 className="font-bold"> Payment Outside :- </h5>
                  {customTrFields.map((field, index) => (
                    <div key={index}>
                      <input
                        type="number"
                        placeholder="Amount"
                        value={field.amount}
                        onChange={
                          isAmountEdit
                            ? (e) => {
                                const newFields = [...customTrFields];
                                newFields[index].amount = e.target.value;
                                setCustomTrFields(newFields);
                              }
                            : undefined
                        }
                        disabled={!isAmountEdit}
                        className="border p-2 rounded w-1/2 col-3"
                        required="required"
                      />
                      <input
                        type="text"
                        placeholder="Name"
                        value={field.name}
                        onChange={(e) => {
                          const newFields = [...customTrFields];
                          newFields[index].name = e.target.value;
                          setCustomTrFields(newFields);
                        }}
                        className="border p-2 rounded w-1/2 col-8"
                        required="required"
                      />
                      {isAmountEdit && customTrFields.length > 0 && (
                        <button
                          type="button"
                          onClick={() =>
                            removeField(index, customTrFields, setCustomTrFields)
                          }
                          className="p-2 bg-red-500 text-white rounded col-1"
                        >
                          -
                        </button>
                      )}
                    </div>
                  ))}
                  {isAmountEdit && (
                    <button
                      type="button"
                      onClick={addCustomTrField}
                      className="mt-2 p-2 bg-yellow-500 text-white rounded"
                    >
                      Add More
                    </button>
                  )}
                  <div className="mt-4 p-2 bg-yellow-300 text-black font-bold rounded">
                    Total Custom Tr Amount: {getCustomTotal()}
                  </div>
                </div>
                <div className="col-12 col-md-4 bg-blue-100 rounded">
                  <h5 className="font-bold">Payment Inside:- </h5>
                  {anotherCustomFields.map((field, index) => (
                    <div key={index}>
                      <input
                        type="number"
                        placeholder="Amount"
                        value={field.amount}
                        onChange={
                          isAmountEdit
                            ? (e) => {
                                const newFields = [...anotherCustomFields];
                                newFields[index].amount = e.target.value;
                                setAnotherCustomFields(newFields);
                              }
                            : undefined
                        }
                        disabled={!isAmountEdit}
                        className="border p-2 rounded w-1/2 col-3"
                        required="required"
                      />
                      <input
                        type="text"
                        placeholder="Name"
                        value={field.name}
                        onChange={(e) => {
                          const newFields = [...anotherCustomFields];
                          newFields[index].name = e.target.value;
                          setAnotherCustomFields(newFields);
                        }}
                        className="border p-2 rounded w-1/2 col-8"
                        required="required"
                      />
                      {isAmountEdit && anotherCustomFields.length > 0 && (
                        <button
                          type="button"
                          onClick={() =>
                            removeField(
                              index,
                              anotherCustomFields,
                              setAnotherCustomFields
                            )
                          }
                          className="p-2 bg-red-500 text-white rounded col-1"
                        >
                          -
                        </button>
                      )}
                    </div>
                  ))}
                  {isAmountEdit && (
                    <button
                      type="button"
                      onClick={addAnotherCustomField}
                      className="mt-2 p-2 bg-purple-500 text-white rounded"
                    >
                      Add More
                    </button>
                  )}
                  <div className="mt-4 p-2 bg-yellow-300 text-black font-bold rounded">
                    Total Payment Inside Amount: {getAnotherCustomTotal()}
                  </div>
                </div>
                <div className="col-12 col-md-4 bg-blue-100 rounded">
                  <h5 className="font-bold">Bank Deposit:- </h5>
                  {BankDepositfields.map((field, index) => (
                    <div key={index}>
                      <input
                        type="number"
                        placeholder="Amount"
                        value={field.amount}
                        onChange={
                          isAmountEdit
                            ? (e) => {
                                const newFields = [...BankDepositfields];
                                newFields[index].amount = e.target.value;
                                setBankDepositfields(newFields);
                              }
                            : undefined
                        }
                        disabled={!isAmountEdit}
                        className="border p-2 rounded w-1/2 col-3"
                        required="required"
                      />
                      <input
                        type="text"
                        placeholder="Bank Name"
                        value={field.name}
                        onChange={(e) => {
                          const newFields = [...BankDepositfields];
                          newFields[index].name = e.target.value;
                          setBankDepositfields(newFields);
                        }}
                        className="border p-2 rounded w-1/2 col-8"
                        required="required"
                        list="bank_name-suggestions"
                      />
                      {isAmountEdit && BankDepositfields.length > 0 && (
                        <button
                          type="button"
                          onClick={() =>
                            removeField(
                              index,
                              BankDepositfields,
                              setBankDepositfields
                            )
                          }
                          className="p-2 bg-red-500 text-white rounded col-1"
                        >
                          -
                        </button>
                      )}
                    </div>
                  ))}
                  {isAmountEdit && (
                    <button
                      type="button"
                      onClick={addBankDepositfields}
                      className="mt-2 p-2 bg-purple-500 text-white rounded"
                    >
                      Add More
                    </button>
                  )}
                  <div className="mt-4 p-2 bg-yellow-300 text-black font-bold rounded">
                    Total Bank Deposit Amount: {getBankDepositfields()}
                  </div>
                </div>
                <div className="col-12 col-md-4 bg-blue-100 rounded">
                  <h5 className="font-bold">Bank Charges:- </h5>
                  {BankChargesfields.map((field, index) => (
                    <div key={index}>
                      <input
                        type="text"
                        placeholder="Bank Name"
                        value={field.bank_name}
                        onChange={(e) => {
                          const newFields = [...BankChargesfields];
                          newFields[index].bank_name = e.target.value;
                          setBankChargesfields(newFields);
                        }}
                        className="border p-2 rounded w-1/2 col-8"
                        required="required"
                        list="bank_name-suggestions"
                      />
                      <input
                        type="number"
                        placeholder="Amount"
                        value={field.amount}
                        onChange={
                          isAmountEdit
                            ? (e) => {
                                const newFields = [...BankChargesfields];
                                newFields[index].amount = e.target.value;
                                setBankChargesfields(newFields);
                              }
                            : undefined
                        }
                        className="border p-2 rounded w-1/2 col-3"
                        required="required"
                      />
                      <input
                        type="text"
                        placeholder="Name"
                        value={field.name}
                        onChange={(e) => {
                          const newFields = [...BankChargesfields];
                          newFields[index].name = e.target.value;
                          setBankChargesfields(newFields);
                        }}
                        className="border p-2 rounded w-1/2 col-8"
                        required="required"
                      />
                      {isAmountEdit && BankChargesfields.length > 0 && (
                        <button
                          type="button"
                          onClick={() =>
                            removeField(
                              index,
                              BankChargesfields,
                              setBankChargesfields
                            )
                          }
                          className="p-2 bg-red-500 text-white rounded col-1"
                        >
                          -
                        </button>
                      )}
                    </div>
                  ))}
                  {isAmountEdit && (
                    <button
                      type="button"
                      onClick={addBankChargesfields}
                      className="mt-2 p-2 bg-purple-500 text-white rounded"
                    >
                      Add More
                    </button>
                  )}
                  <div className="mt-4 p-2 bg-yellow-300 text-black font-bold rounded">
                    Total Bank Charges Amount: {getBankChargesfields()}
                  </div>
                </div>
                <div className="col-12 col-md-4 bg-blue-100 rounded">
                  <h5 className="font-bold">Bank Statement:- </h5>
                  {BankDepositChargefields && BankDepositChargefields.data && BankDepositChargefields.data.length > 0 && (
                    <>
                      <label className="border p-2 rounded w-1/4 col-3" >Bank Name</label>
                      <label className="border p-2 rounded w-1/4 col-3" >Deposite</label>
                      <label className="border p-2 rounded w-1/4 col-3" >Charges</label>
                      <label className="border p-2 rounded w-1/4 col-3" >Total</label>
                    
                    {BankDepositChargefields.data.map((field, index) => (
                      <div key={index}>
                      <input
                        type="text"
                        placeholder="Bank Name"
                        value={field.bank_name}
                        className="border p-2 rounded w-1/4 col-3"
                        disabled
                      />
                      <input
                        type="text"
                        placeholder="Deposite"
                        value={field.deposite}
                        className="border p-2 rounded w-1/4 col-3"
                        disabled
                      />
                      <input
                        type="text"
                        placeholder="Charges"
                        value={field.charges}
                        className="border p-2 rounded w-1/4 col-3"
                        disabled
                      />
                      <input
                        type="text"
                        placeholder="Total"
                        value={field.total}
                        className="border p-2 rounded w-1/4 col-3"
                        disabled
                      />
                      </div>
                    ))}

                      <label className="border p-2 rounded w-1/4 col-3" >&nbsp;</label>
                      <label className="border p-2 rounded w-1/4 col-3" >&nbsp;</label>
                      <label className="border p-2 rounded w-1/4 col-3" >Deposite</label>
                      <label className="border p-2 rounded w-1/4 col-3" >{BankDepositChargefields.all_bank_total_deposite}</label>

                      <label className="border p-2 rounded w-1/4 col-3" >&nbsp;</label>
                      <label className="border p-2 rounded w-1/4 col-3" >&nbsp;</label>
                      <label className="border p-2 rounded w-1/4 col-3" >Charges</label>
                      <label className="border p-2 rounded w-1/4 col-3" >{BankDepositChargefields.all_bank_total_charges}</label>

                      <label className="border p-2 rounded w-1/4 col-3" >&nbsp;</label>
                      <label className="border p-2 rounded w-1/4 col-3" >&nbsp;</label>
                      <label className="border p-2 rounded w-1/4 col-3" >Total</label>
                      <label className="border p-2 rounded w-1/4 col-3" >{BankDepositChargefields.all_bank_bank_total}</label>
                    </>
                  )}
                </div>
                <div className="col-12 bg-blue-100 rounded">
                  Previous day Total: {previous_day_total}
                </div>
                <div className="col-12 bg-blue-100 rounded">
                  Current day Total: {Current_day_total()}
                </div>
                <div className="col-12 bg-blue-100 rounded">
                  Net Total: {Net_total()}
                </div>
                <div className="col-12 bg-blue-100 rounded">
                  Final Total: {Final_total()}
                </div>

                {isLoggedIn && (
                  <div className="col-md-12 col-12">
                    <button className="btn bt-form" type="submit" disabled={loading}>
                      {loading ? "Adding..." : "Add Product"}
                    </button>
                    {error && <p style={{ color: "red" }}>{error}</p>}
                    {success && <p style={{ color: "green" }}>{success}</p>}
                  </div>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
      <Header />
    </>    
  );
};
export default Managerreadingedit;
